import { Model } from '@vuex-orm/core'

export class Supervisor extends Model {
  static entity = 'supervisors'
  static primaryKey = 'license'

  static fields() {
    return {
      license: this.string(),
      name: this.string(),
      hospital: this.string(),
      specialty: this.string(),
      role: this.string()
    }
  }

  static fetch() {
    const supervisors = Supervisor.query().get()
    if (!supervisors.length) {
      // return fetch('httplocalhost:3000/content/supervisors')
      return fetch(`${process.env.VUE_APP_API_URL}/content/supervisors`)
        .then(data => data.json())
        .then(data => this.create({ data }))
    } else {
      return Promise.resolve(supervisors)
    }
  }
}
export class Hospital extends Model {
  static entity = 'hospitals'
  static primaryKey = 'id'

  static fields() {
    return {
      id: this.string(),
      name: this.string(),
      fullName: this.string()
    }
  }

  get text() {
    return this.name
  }

  get value() {
    return this.id
  }

  static fetch() {
    const hospitals = Hospital.query().get()
    const query = process.env.NODE_ENV === 'development' ? '?env=dev' : ''
    if (!hospitals.length) {
      return fetch(`${process.env.VUE_APP_API_URL}/content/hospitals/${query}`)
        .then(data => data.json())
        .then(data => this.create({ data }))
        .catch(err => this.dispatch('showErrorSnackbar', err))
    } else {
      return Promise.resolve(hospitals)
    }
  }
}

export class HealthCenterGroup extends Model {
  static entity = 'healthCenterGroups'
  static primaryKey = 'id'

  static fields() {
    return {
      id: this.string(),
      name: this.string(),
      fullName: this.string()
    }
  }
  get text() {
    return this.name
  }

  get value() {
    return this.id
  }

  static fetch() {
    const healthCenterGroups = HealthCenterGroup.query().get()
    const query = process.env.NODE_ENV === 'development' ? '?env=dev' : ''
    if (!healthCenterGroups.length) {
      return fetch(
        `${process.env.VUE_APP_API_URL}/content/healthcentergroups/${query}`
      )
        .then(data => data.json())
        .then(data => this.create({ data }))
        .catch(err => this.dispatch('showErrorSnackbar', err))
    } else {
      return Promise.resolve(healthCenterGroups)
    }
  }
}
export class Sponsors extends Model {
  static entity = 'sponsors'
  static primaryKey = 'name'

  static fields() {
    return {
      name: this.string(),
      itemTitle: this.string(),
      itemText: this.string(),
      subgroup: this.string(),
      group: this.string(),
      show: this.attr(false),
      externalLink: this.string(),
      airtableLink: this.attr([]),
      sponsor: this.string(),
      specialty: this.attr([])
    }
  }

  static fetch() {
    const sponsors = Sponsors.query().get()
    if (!sponsors.length) {
      return fetch(`${process.env.VUE_APP_API_URL}/content/sponsor`)
        .then(data => data.json())
        .then(data => this.create({ data }))
        .catch(err => this.dispatch('showErrorSnackbar', err))
    } else {
      return Promise.resolve(sponsors)
    }
  }
}

export class InternshipsSpecialty extends Model {
  static entity = 'internshipsSpecialty'
  static primaryKey = 'id'

  static fields() {
    return {
      id: this.string(),
      name: this.string(),
      internshipSpeciality: this.string(),
      specialities: this.attr([])
    }
  }

  static fetch() {
    const internships = InternshipsSpecialty.query().get()
    const query = process.env.NODE_ENV === 'development' ? '?env=dev' : ''
    if (!internships.length) {
      return fetch(`${process.env.VUE_APP_API_URL}/content/internship/${query}`)
        .then(data => data.json())
        .then(data => this.create({ data }))
        .catch(err => this.dispatch('showErrorSnackbar', err))
    } else {
      return Promise.resolve(internships)
    }
  }
}

export class AgeOption extends Model {
  static entity = 'ageOption'
  static primaryKey = 'value'

  static fields() {
    return {
      text: this.string(),
      value: this.string(),
      minValue: this.number(0),
      maxValue: this.number(0),
      component: this.string()
    }
  }

  static fetch(specialty) {
    const ageOptions = AgeOption.query().get()
    if (!ageOptions.length) {
      return fetch(
        `${process.env.VUE_APP_API_URL}/content/age-options/${specialty}`
      )
        .then(data => data.json())
        .then(data => this.create({ data }))
        .catch(err => this.dispatch('showErrorSnackbar', err))
    } else {
      return Promise.resolve(ageOptions)
    }
  }
}
